import angular from 'angular';
import commissionUnmatchedSummary from './commissionUnmatchedSummary';

export default angular
  .module(
    'commission.scenes.commissionManagement.scenes.commissionLanding.scenes.commissionUnmatchedSummary',
    [],
  )
  .component('commissionUnmatchedSummary', commissionUnmatchedSummary).name;
